import { createAction, makeActionTrackable } from '@lingoda/core';

export default makeActionTrackable(createAction<string>('payment/FETCH_PAYMENT_METHODS'));
